import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class TahsilatBilgileriListeAPI extends BaseAPI {


    constructor() {
        const baseUrl = environment.API_URL + "TahsilatBilgileriListe";
        super(baseUrl);
    }


    getTahsilatBilgileriListe(sicilKodu: number, ilkTarih: string, sonTarih: string, makbuzNo?: number) {
        var request = new TahsilatBilgileriListeRequest(sicilKodu, ilkTarih, sonTarih, makbuzNo);
        return this.post("", request, false);
    }

}
export default new TahsilatBilgileriListeAPI();
class TahsilatBilgileriListeRequest {
    public sicilKodu: number;
    public ilkTarih: string;
    public sonTarih: string;
    public makbuzNo?: number;
    constructor(sicilKodu: number, ilkTarih: string, sonTarih: string, makbuzNo?: number) {

        this.sicilKodu = sicilKodu;
        this.ilkTarih = ilkTarih;
        this.sonTarih = sonTarih;
        this.makbuzNo = makbuzNo;

    }
}
export { TahsilatBilgileriListeRequest };